import React, { FC, useEffect } from "react";

import { Text, RichText } from "@sitecore-jss/sitecore-jss-react";
import RoutableNotEditableLink from "../../../../react-only-components/RoutableNotEditableLink";
import { TOverviewTextProps } from "../../types/OverviewText.type";
import { OverviewTextModel } from "../../models/OverviewText.model";
import "./styles.scss";

const OverviewText: FC<TOverviewTextProps> = (props) => {
  const model = new OverviewTextModel(props);

  useEffect(() => {
    if (typeof window !== 'undefined' && 'customElements' in window) {
      import('@patternfly/pfe-icon-onhighway/dist/pfe-icon.js');
    }
  }, []);

  return (
    <div className="series-overview-text">
      <Text
        field={model.eyebrow}
        tag="p"
        className="series-overview-text__eyebrow"
        editable={false}
      />
      <Text
        field={model.title}
        tag="h2"
        className="series-overview-text__title"
        editable={false}
      />
      <RichText
        field={model.description}
        tag="div"
        className="series-overview-text__description"
        editable={false}
      />
      {model?.primaryLink?.label && model?.primaryLink?.url && (
        <span
          className={
            "series-overview-text__link series-overview-text__link--primary"
          }
        >
          <pfe-cta pfe-priority="primary">
            <RoutableNotEditableLink href={model.primaryLink.url}>
              {model.primaryLink.label}
            </RoutableNotEditableLink>
          </pfe-cta>
        </span>
      )}
      {model?.secondaryLink?.label && model?.secondaryLink?.url && (
        <span
          className={
            "series-overview-text__link series-overview-text__link--secondary"
          }
        >
          <RoutableNotEditableLink href={model.secondaryLink.url}>
            {model.secondaryLink.label}
          </RoutableNotEditableLink>
          <pfe-icon
            icon="dcx-arrow-forward"
            size="24"
            color="complement"
          ></pfe-icon>
        </span>
      )}
    </div>
  );
};

export default OverviewText;
